import { serverURL, apiPost } from '../../../../../common/utils/fetch_utils';
import {
  AUTHENTICATE_FAILED,
  GET_DETAILS_SUCCESS,
  AUTHENTICATING,
  AUTHENTICATING_COMPLETE,
  AUTHENTICATED,
} from '../../../../redux/modules/user';
import { msgError } from '../../../../CommonCreators';
import getUrlParamaterByName from '../../../../utils/auth';
import { AuthFormValues, AuthResult } from '../components/AuthView';
import { Dispatch } from 'redux';

export function getDetailsSuccess(response: any, dispatch: any) {
  return (dispatch: any) => {
    dispatch({ response, type: GET_DETAILS_SUCCESS });
  };
}

export function authenticateFailed(response: any, dispatch: any) {
  return (dispatch: any) => {
    dispatch({ response, type: AUTHENTICATE_FAILED });
  };
}

export function authenticating(dispatch: any) {
  return (dispatch: any) => {
    dispatch({ type: AUTHENTICATING });
  };
}

export function authenticatingComplete(dispatch: any) {
  return (dispatch: any) => {
    dispatch({ type: AUTHENTICATING_COMPLETE });
  };
}

export function authenticated(dispatch: any) {
  return (dispatch: any) => {
    dispatch({ type: AUTHENTICATED });
  };
}

export const authenticate = (
  values: AuthFormValues,
  callback: Function,
  dispatch: any,
  reset?: boolean,
  errorRoute?: string,
) => {
  return async () => {
    try {
      dispatch(authenticating(dispatch));
      const token = getUrlParamaterByName('authToken');
      const postBody: any = {
        code: values.code,
        token,
      };
      if (values.access_token) postBody.access_token = values.access_token;
      const response = await apiPost(
        `${serverURL}/api/accounts/authCode`,
        postBody,
        errorRoute,
      );
      if (!response || !response.success) {
        dispatch(authenticatingComplete(dispatch));
        throw new Error(response.error);
      }
      if (callback) {
        callback(response.result);
      }
      dispatch(authenticated(dispatch));
    } catch (error) {
      dispatch(authenticateFailed(error, dispatch));
      dispatch(authenticatingComplete(dispatch));
      console.error(error);
    }
  };
};

export const resetCode = () => {
  return async () => {
    try {
      const token = getUrlParamaterByName('authToken');
      const response = await apiPost(
        `${serverURL}/api/accounts/authCode/reset`,
        { token },
      );
      if (!response || !response.success) {
        throw new Error(response.error);
      }
      console.log('received response: ', response);
    } catch (e) {
      console.log(e);
    }
  };
};

export const getDetails = (dispatch: any) => {
  return async () => {
    try {
      const token = getUrlParamaterByName('authToken');
      const result = await apiPost(
        `${serverURL}/api/accounts/authCode/getDetails`,
        { token },
      );
      if (!result || !result.success) {
        throw new Error(result.error);
      }
      dispatch(getDetailsSuccess(result, dispatch));
      console.log('received getDetails response: ', result);
    } catch (e) {
      console.log(e);
    }
  };
};
